import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=0370e234&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=js"
export * from "./TableWidget.vue?vue&type=script&lang=js"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=0370e234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370e234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0370e234')) {
      api.createRecord('0370e234', component.options)
    } else {
      api.reload('0370e234', component.options)
    }
    module.hot.accept("./TableWidget.vue?vue&type=template&id=0370e234&scoped=true", function () {
      api.rerender('0370e234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/TableWidget.vue"
export default component.exports